import React from 'react';
import './ConfirmModal.scss';
import { useIsReadOnly } from '../../context/UserContextProvider';

const ConfirmModal = ({ onClose, modalMessage, modalAction }) => {
  const isReadOnly = useIsReadOnly();
  return (
    <div className="confirm-content">
      <span>{modalMessage}</span>
      <div className="actions">
        <button className="cancel" onClick={onClose}>
          Cancel
        </button>
        <button
          className={`confirm ${isReadOnly ? 'disabled' : ''}`}
          onClick={() => {
            modalAction();
            onClose();
          }}
          disabled={isReadOnly}
        >
          Confirm
        </button>
      </div>
    </div>
  );
};

export { ConfirmModal };
export default ConfirmModal;
